(function () {
  "use strict";

  // Guard against the script being loaded twice (section reloads, theme editor).
  if (window.__glozinWishlistLoaded) return;
  window.__glozinWishlistLoaded = true;

  var WISHLIST_KEY = "glozin__wishlist-items";

  function readWishlist() {
    try {
      var parsed = JSON.parse(localStorage.getItem(WISHLIST_KEY));
      return Array.isArray(parsed) ? parsed : null;
    } catch (e) {
      return null;
    }
  }

  var wishlist_items = readWishlist();
  var wishlistDiv = document.querySelector(".wishlist-page-main");

  /* ------------------------------------------------------------------ */
  /* Wishlist page                                                       */
  /* ------------------------------------------------------------------ */
  var WishlistPageShopify = {
    initWishlistItems: function () {
      if (window.location.search.indexOf("page=") == -1) {
        this.init();
      }
    },

    init: function () {
      var _this = this;
      if (!wishlistDiv) return;

      var div_no_product = wishlistDiv.querySelector(
        ".wishlist-no-product-js"
      );

      if (wishlist_items === null || wishlist_items.length === 0) {
        _this.skeletonFunction(0);
        if (div_no_product) div_no_product.classList.remove("hidden");
        return;
      }

      var sectionEl = document.querySelector(".wishlist-page-section");
      if (!sectionEl) return;

      var query = wishlist_items.join("%20OR%20id:");
      var productAjaxURL =
        "?section_id=" +
        sectionEl.dataset.sectionId +
        "&type=product&options[unavailable_products]=last&q=id:" +
        query;

      fetch(window.routes.search_url + productAjaxURL)
        .then(function (response) {
          if (!response.ok) {
            throw new Error("Wishlist fetch failed: " + response.status);
          }
          return response.text();
        })
        .then(function (responseText) {
          var html = new DOMParser().parseFromString(responseText, "text/html");
          var exist_row = wishlistDiv.querySelector(".wishlist-list-items");
          if (exist_row) exist_row.remove();

          var er = html.querySelector(
            ".wishlist-page-main .wishlist-list-items"
          );
          if (er) {
            wishlistDiv.innerHTML = html.querySelector(
              ".wishlist-page-main"
            ).innerHTML;
            _this.skeletonFunction(700);
            // Only sync storage after a successful render.
            _this.mergeItems();
          } else {
            _this.skeletonFunction(0);
            if (div_no_product) div_no_product.classList.remove("hidden");
            // Deliberately NOT calling mergeItems(): an empty/odd response
            // must never wipe the saved wishlist.
          }
        })
        .catch(function (e) {
          console.error(e);
          // Reveal the page; saved items stay intact.
          _this.skeletonFunction(0);
        })
        .finally(function () {
          if (typeof initLazyloadItem === "function") {
            initLazyloadItem();
          }
        });
    },

    // Read product IDs from the rendered cards (.pi-card), falling back to
    // the old button-wishlist markup.
    getRenderedIds: function () {
      var ids = new Set();
      if (!wishlistDiv) return [];

      wishlistDiv.querySelectorAll(".pi-card").forEach(function (card) {
        var inner = card.querySelector("[data-product-id]");
        var id =
          card.dataset.productId ||
          card.dataset.id ||
          (inner && inner.dataset.productId);
        if (id) ids.add(String(id));
      });

      if (ids.size === 0) {
        wishlistDiv
          .querySelectorAll(".product-item__action button-wishlist")
          .forEach(function (e) {
            if (e && e.dataset.productId) ids.add(String(e.dataset.productId));
          });
      }

      return Array.from(ids);
    },

    mergeItems: function () {
      var arr = this.getRenderedIds();
      if (arr.length === 0) return; // keep existing saved items
      localStorage.setItem(WISHLIST_KEY, JSON.stringify(arr));
    },

    skeletonFunction: function (timer) {
      window.setTimeout(function () {
        var skeleton = document.querySelector("skeleton-page");
        if (skeleton) skeleton.remove();
        var inner = document.querySelector(".wishlist-page-section-inner");
        if (inner) inner.classList.remove("hidden");
      }, timer);
    },
  };

  // Keep the original global in case other theme code references it.
  window.WishlistPageShopify = WishlistPageShopify;
  WishlistPageShopify.initWishlistItems();

  /* ------------------------------------------------------------------ */
  /* Add to cart from the wishlist (no page reload)                      */
  /* ------------------------------------------------------------------ */
  var CART_COUNT_SELECTORS = [
    ".cart-count",
    ".cart-count-bubble",
    ".cart-count-bubble span[aria-hidden='true']",
    ".header__cart-count",
    "[data-cart-count]",
    "cart-count",
  ].join(",");

  function updateCartUI(cart) {
    document.querySelectorAll(CART_COUNT_SELECTORS).forEach(function (el) {
      el.textContent = cart.item_count;
      el.classList.remove("hidden");
    });

    // Let the theme (drawer, header, etc.) react if it listens for these.
    ["cart:refresh", "cart:updated"].forEach(function (name) {
      document.dispatchEvent(
        new CustomEvent(name, { detail: { cart: cart }, bubbles: true })
      );
    });
  }

  // Capture phase + stopImmediatePropagation so the theme's own submit
  // handler can't also fire and add the product a second time.
  document.addEventListener(
    "submit",
    async function (event) {
      var form = event.target;

      if (
        !(form instanceof HTMLFormElement) ||
        !form.matches(".wishlist-page-main .pi-form")
      ) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      if (form.dataset.adding === "true") return;

      var button = form.querySelector('button[type="submit"]');
      var message = form.querySelector(".wishlist-cart-message");
      if (!message) {
        message = document.createElement("p");
        message.className = "wishlist-cart-message";
        message.setAttribute("role", "status");
        message.setAttribute("aria-live", "polite");
        form.appendChild(message);
      }
      message.textContent = "";

      var formData = new FormData(form);
      if (!formData.get("id")) {
        message.textContent = "Please choose an option on the product page.";
        return;
      }

      form.dataset.adding = "true";
      var originalHTML = button ? button.innerHTML : "";
      if (button) {
        button.disabled = true;
        button.textContent = "Adding…";
      }

      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";

      try {
        var response = await fetch(root + "cart/add.js", {
          method: "POST",
          body: formData,
          headers: { Accept: "application/json" },
        });
        var result = await response.json();

        if (!response.ok) {
          throw new Error(
            result.description || result.message || "Unable to add this item."
          );
        }

        message.textContent = "Added to cart.";

        // The item is already in the cart even if refreshing the count fails.
        try {
          var cartResponse = await fetch(root + "cart.js", {
            headers: { Accept: "application/json" },
            cache: "no-store",
          });
          if (cartResponse.ok) {
            updateCartUI(await cartResponse.json());
          }
        } catch (countError) {
          console.warn("Item added, but cart UI could not refresh.", countError);
        }
      } catch (error) {
        message.textContent =
          error.message || "Unable to add this item. Please try again.";
      } finally {
        delete form.dataset.adding;
        if (button) {
          button.disabled = false;
          button.innerHTML = originalHTML;
        }
      }
    },
    true
  );
})();